import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";

const initialContactState = {
  contact: {},
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

const initialState = {
  organizations: {},
  properties: {},
};

export const currentContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CURRENT_CONTACT:
    case types.SET_CURRENT_CONTACT_REQUEST_STATUS: {
      const { organizationId, propertyId, ...rest } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: {
            ...(state[key]?.[id] || initialContactState),
            ...rest,
          },
        },
      };
    }
    case types.UPDATE_CURRENT_CONTACT: {
      const { organizationId, propertyId, updatedContact, status, err } = action.payload;
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      return {
        ...state,
        [key]: {
          ...state[key],
          [id]: {
            ...(state[key]?.[id] || initialContactState),
            contact: updatedContact,
            status,
            err,
          },
        },
      };
    }
    case types.RESET_CURRENT_CONTACT: {
      const { organizationId, propertyId } = action.payload || {};
      const key = organizationId ? "organizations" : "properties";
      const id = organizationId ?? propertyId;

      if (id) {
        return {
          ...state,
          [key]: {
            ...state[key],
            [id]: initialContactState,
          },
        };
      }

      return initialState;
    }
    default:
      return state;
  }
};
